import React, {useEffect} from 'react';

import Modal from '@mui/material/Modal';


import { useResponsive } from '../hooks/useResponsive';
import { useSelector, useDispatch } from 'react-redux';
import { InfoModalContainer } from '../components/Modal/InfoModal';
import { useModal } from '../hooks/useModal';
import { closeSearch } from '../slices/searchSlice';

export const MenuModalContainer = () => {

  const { isMobile, isDesktop } = useResponsive();

  const dispatch = useDispatch();

  const style = {
    modalStyle: {
      display: 'flex',
      width: '70%',
      alignItems: 'center',
      justifyContent: 'center',
      top: 'unset',
      bottom: 'unset',
      left: 'unset',
      right: 'unset'
    }
  };

  const {handleCloseModalMenu} = useModal();

  const openModal = useSelector(state => state.menu.modalOpen);

  useEffect(() => {
    if(!isDesktop && openModal) {
      dispatch(closeSearch());
    }
  }, [isDesktop, openModal]);

  return (
    <React.Fragment>
      {isMobile ? (
        <React.Fragment>
          {openModal && (
            <InfoModalContainer />
          )}
        </React.Fragment>
      ) : (
        <Modal 
          open={openModal} 
          sx={style.modalStyle}
          onClose={handleCloseModalMenu}
          disablePortal
        >
          <React.Fragment>
            <InfoModalContainer />
          </React.Fragment>
        </Modal>
      )}
    </React.Fragment>
  );
};